/**
 * VisionEngine registry — add engines here; shell only reads the list.
 */

import type { VisionEngine, VisionEngineId } from "./types";
import { createGestureEngine } from "./gestureEngine";
import { createVlmEngine } from "./vlmEngine";
import { createScreenEngine } from "./screenEngine";

const engines = new Map<VisionEngineId, VisionEngine>();

function ensureDefaults(): void {
  if (engines.size > 0) return;
  registerEngine(createGestureEngine());
  registerEngine(createVlmEngine());
  registerEngine(createScreenEngine());
}

export function registerEngine(engine: VisionEngine): void {
  engines.set(engine.id, engine);
}

export function getEngine(id: VisionEngineId): VisionEngine | undefined {
  ensureDefaults();
  return engines.get(id);
}

export function listEngines(): VisionEngine[] {
  ensureDefaults();
  return Array.from(engines.values());
}

export function listEnginesByKind(kind: "live" | "ask"): VisionEngine[] {
  return listEngines().filter((e) => e.kind === kind);
}
